export default {
    path: '/',
    component: () => import('@/views/linehaul/Index'),
    children: [
    // Dashboard
        {
            name: 'Return Scan',
            path: '',
            component: () => import('@/views/linehaul/return/Scan'),
            meta: {
                requiresAuth: true,
                coolrunnerOnly: true,
            },
        },
        {
            name: 'return_list',
            path: 'return/list',
            component: () => import('@/views/linehaul/return/List'),
            meta: {
                requiresAuth: true,
                coolrunnerOnly: true,

            },
        },
        {
            name: 'return_outsorting',
            path: 'return/outsorting',
            component: () => import('@/views/linehaul/return/Outsorting'),
            meta: {
                requiresAuth: true,
                coolrunnerOnly: true,

            },
        },
        {
            name: 'return_scan',
            path: 'return/scan',
            component: () => import('@/views/linehaul/return/Scan'),
            meta: {
                requiresAuth: true,
                coolrunnerOnly: true,

            },
        },
        {
            name: 'cooleurope_scan',
            path: 'cooleurope',
            component: () => import('@/views/linehaul/cooleurope/Scan'),
            meta: {
                requiresAuth: true,
                coolrunnerOnly: true,

            },
        },
        {
            name: 'homerunner_scan',
            path: 'homerunner/scan',
            component: () => import('@/views/linehaul/homerunner/Scan'),
            meta: {
                requiresAuth: true,
                coolrunnerOnly: false,

            },
        },
        {
            name: 'homerunner_districts',
            path: 'homerunner/districts',
            component: () => import('@/views/linehaul/homerunner/Districts'),
            meta: {
                requiresAuth: true,
                coolrunnerOnly: false,

            },
        },
        {
            name: 'homerunner_outsorting',
            path: 'homerunner/outsorting',
            component: () => import('@/views/linehaul/homerunner/Outsorting'),
            meta: {
                requiresAuth: true,
                coolrunnerOnly: false,

            },
        },
        {
            name: 'tools_duplicate_label',
            path: 'tools/duplicate-label',
            component: () => import('@/views/linehaul/tools/DuplicateLabel'),
            meta: {
                requiresAuth: true,
                coolrunnerOnly: false,

            },
        },
        {
            name: 'transitrelabeling',
            path: 'transitrelabeling',
            component: () => import('@/views/linehaul/transitrelabeling/Scan'),
            meta: {
                requiresAuth: true,
                coolrunnerOnly: false,

            },
        },

    ],
}
